import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom';

import {
  CCloseButton,
  CSidebar,
  CSidebarBrand,
  CSidebarFooter,
  CSidebarHeader,
  CSidebarToggler,
} from '@coreui/react'
import { AppSidebarNav } from './AppSidebarNav'
import logo from '../assets/images/UPG_site_logo.png';
// sidebar nav config
import Admin_nav from '../admin_nav'
import Participant_nav from '../participant_nav'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const narrow = useSelector((state) => state.narrow)
  const user_data = useSelector((state) => state.user);
  const user_role = localStorage.getItem('role');
  const [role, setRole] = useState('');


  useEffect(() => {
    if (user_data != null && user_data.role != undefined || user_role != null) {
      setRole(user_data != undefined && user_data.role != undefined ? user_data.role : user_role);
    }
    console.log(narrow);
  }, [user_data, narrow]);
  return (
    <CSidebar
      className="border-end new_sidebar_mobile"
      colorScheme="dark"
      position="fixed"
      narrow={narrow}
      size='md'
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarHeader className="border-bottom justify-content-center">
        <Link to="/dashboard" className=''>
          <img
            src={logo}
            className="img-fluid rounded-top"
            alt="logo"
            height={80}
            width={80}
          />
        </Link>
        <CCloseButton
          className="d-lg-none"
          dark
          onClick={() => { 
            dispatch({ type: 'NARROW', sidebarShow: true })
            console.log("you clicked btn")
          }
          }
        />
      </CSidebarHeader>
      <AppSidebarNav items={Admin_nav} />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
